import React, { useState } from 'react';

// Material
import { makeStyles } from '@material-ui/core/styles';

// Components and Others
import clsx from 'clsx';
import { isFinite } from 'lodash';
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import { Button, fade } from '@material-ui/core';
import Header from 'components/widgets/Header';
import ButtonStyles from 'styles/theme/Button';
import DealStyles from 'styles/modules/DealStyles';
import Container from 'components/widgets/Container';
import BackButton from 'components/widgets/BackButton';
import { useParams, useHistory } from 'react-router-dom';
import { modules } from 'utils/enum/modules';
import DealDetailHeader from 'components/widgets/deals/DealDetailHeader';
import DealTabs from 'components/modules/deals/read/dealTab/DealTabs';
import ResponsiveTabsNav from 'components/widgets/ResponsiveTabsNav';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme, fade));
const useStyles = makeStyles((theme) => DealStyles.details(theme));

const DealDetail = () => {
    const classes = { ...useStyles(), ...buttonStyles() };
    const history = useHistory();
    const { id } = useParams();
    const accountNumber = parseInt(id, 10);
    const [activeTab, setActiveTab] = useState(0);
    const keyStore = new KeyStore();
    const DEALS_DOCUMENTS_READ = keyStore.hasPermission(Permission.DEALS_DOCUMENTS_READ);
    const SALES_DEAL_FORMS_READ = keyStore.hasPermission(Permission.SALES_DEAL_FORMS_READ);
    const SALES_DEAL_VEHICLE_READ = keyStore.hasPermission(Permission.SALES_DEAL_VEHICLE_READ);
    const SALES_DEAL_CUSTOMER_READ = keyStore.hasPermission(Permission.SALES_DEAL_CUSTOMER_READ);
    const SALES_CREDIT_PULL_READ = keyStore.hasPermission(Permission.SALES_CREDIT_PULL_READ);

    // Implement redirect to error page 403 from ProtectedRouter component
    if (!isFinite(accountNumber)) {
        history.push('/');
        return null;
    }

    const tabs = [{ title: 'Deal' }];

    if (SALES_DEAL_CUSTOMER_READ) {
        tabs.push({ title: 'Buyer' });
    }

    if (SALES_DEAL_VEHICLE_READ) {
        tabs.push({ title: 'Vehicles' });
    }

    if (SALES_DEAL_FORMS_READ) {
        tabs.push({ title: 'Forms' });
    }

    tabs.push({ title: 'Credit', disabled: !SALES_CREDIT_PULL_READ });

    if (DEALS_DOCUMENTS_READ) {
        tabs.push({ title: 'Documents' });
    }

    tabs.push({ title: 'History' });

    return (
        <Container className="floatBox">
            <Header>
                <div className={clsx('d-flex-center', classes.header)}>
                    <div className={clsx(classes.numberContainer, classes.dealContainer)}>
                        <BackButton route="/deals" />
                    </div>
                    <div className={classes.headerInfoContainer}>
                        <DealDetailHeader dealId={accountNumber} />
                    </div>
                    <ResponsiveTabsNav
                        tabs={tabs}
                        activeTab={activeTab}
                        navClassName={classes.nav}
                        onTabSelect={setActiveTab}
                    />
                </div>
            </Header>
            <Container className={classes.boxContainer}>
                <a href={`/${modules.DEALS}/${accountNumber}/menu`} target="_blank" rel="noopener noreferrer">
                    <Button
                        className={clsx(classes.menuButton, classes.containedSecondaryInfo)}
                        size="small"
                    >
                        Menu
                    </Button>
                </a>
                <DealTabs
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    accountNumber={accountNumber}
                />
            </Container>
        </Container>
    );
};

export default DealDetail;
